import { render, staticRenderFns } from "./StallionSyndication.vue?vue&type=template&id=1704955a&"
import script from "./StallionSyndication.vue?vue&type=script&lang=js&"
export * from "./StallionSyndication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports